import { useEffect } from "react";
import i18n from "locale";

export const useTranslateFormErrors = (form: any) => useEffect(() => {
    if (i18n.language) {
      form.validateForm();
    }
  }, [i18n.language]);
